import { FALLBACK_LANG, type SupportedLang } from 'app/lang/constants';
import type { InnerLineEntry } from 'app/redux/betting-presentation/grid/selectors';

export function getLineNameByLang(names: InnerLineEntry['names'], lang: SupportedLang) {
  if (!names) {
    return '––';
  }

  const lineNamesByLang = lang in names
    ? names[lang]
    : names[FALLBACK_LANG];
  return lineNamesByLang || '––';
}
